import { useQuery } from '@tanstack/react-query'

import { caaInstance } from '@/modules/caa'
import { AvailabilityTypes } from '@/modules/caa/domain/models/AvailabilityTypes'
import { CAATypes } from '@/modules/caa/domain/models/CAATypes'

export function getListCAAForManagersQueryKey(params: {
  date: string
  patientId?: string
  personaName?: string
  availability?: AvailabilityTypes
  typeCAA?: CAATypes
}) {
  const baseKey = ['listCAAForManagers']
  return params ? [...baseKey, params] : [...baseKey]
}

export function useListCAAForManagersQuery({
  date,
  patientId,
  personaName,
  availability,
  typeCAA,
  enabled
}: {
  date: string
  patientId?: string
  personaName?: string
  availability?: AvailabilityTypes
  typeCAA?: CAATypes
  enabled: boolean
}) {
  return useQuery({
    queryKey: getListCAAForManagersQueryKey({
      date,
      patientId,
      personaName,
      availability,
      typeCAA
    }),
    queryFn: async () => {
      return await caaInstance.listCAAForManagers({
        date,
        patientId,
        personaName,
        availability,
        typeCAA
      })
    },
    enabled: !!date && enabled
  })
}
